import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabsComponent {
  @Input() animationSpeed = 0;
}
